module.exports = __webpack_public_path__ + "img/Team_links.6592cca7.jpg";